import { api } from '@/state/services'
import { extractTextFromPdf } from './pdfExtractor'

const CACHE_PREFIX = 'energia_bill_extract_'
const CACHE_VERSION = 'v3'

async function hashFile(file) {
  const buffer = await file.arrayBuffer()
  const hashBuf = await crypto.subtle.digest('SHA-256', buffer)
  const bytes = new Uint8Array(hashBuf)
  let hex = ''
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0')
  }
  return hex
}

function readCache(key) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const obj = JSON.parse(raw)
    if (obj.version !== CACHE_VERSION) return null
    return obj
  } catch {
    return null
  }
}

function writeCache(key, payload) {
  try {
    localStorage.setItem(key, JSON.stringify(payload))
  } catch {
    /* noop — quota cheia ou storage indisponível */
  }
}

async function callApiExtract(text, fileHash) {
  const { data: resp } = await api.post('energy/extract', {
    text,
    file_hash: fileHash,
  })

  if (!resp || resp.status !== 'success') {
    throw new Error((resp && resp.message) || 'Erro ao extrair fatura via API.')
  }

  return resp.data
}

export async function extractBillFromPdf(file, { forceRefresh = false } = {}) {
  const fileHash = await hashFile(file)
  const cacheKey = `${CACHE_PREFIX}${fileHash}`

  if (!forceRefresh) {
    const cached = readCache(cacheKey)
    if (cached && cached.data) {
      return { data: cached.data, fromCache: true, hash: fileHash }
    }
  }

  const text = await extractTextFromPdf(file)
  if (!text || text.trim().length < 50) {
    const err = new Error('Não foi possível extrair texto suficiente do PDF. Verifique se o arquivo é uma conta de energia legível (não pode ser escaneada em imagem sem OCR).')
    err.code = 'INSUFFICIENT_TEXT'
    throw err
  }

  const data = await callApiExtract(text, fileHash)

  writeCache(cacheKey, {
    version: CACHE_VERSION,
    data,
    extracted_at: new Date().toISOString(),
  })

  return { data, fromCache: false, hash: fileHash }
}

export function clearBillExtractCache() {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i)
    if (k && k.startsWith(CACHE_PREFIX)) localStorage.removeItem(k)
  }
}
